"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var plyr_1 = __importDefault(require("plyr"));
var plyrElements = document.querySelectorAll('[data-plyr]');
plyrElements.forEach(function (element) {
    var player = new plyr_1.default((element), {
        settings: [],
        controls: ['play-large', 'play', 'progress', 'current-time', 'duration', 'mute', 'volume', 'fullscreen'],
        captions: {
            active: false,
        },
        storage: {
            enabled: false,
        },
    });
});
